import { showToast } from '../../../collections/CollectionUI.js';
import { ensureItemsModalState } from './state.js';

export async function viewCollectionItems(id) {
    const collection = this.collections.find((collectionItem) => collectionItem.id == id);
    if (!collection) {
        showToast('error', 'Không tìm thấy collection');
        return;
    }

    if (!collection.item_count || collection.item_count === 0) {
        showToast('info', `Collection "${collection.name}" chưa có dự án nào`);
        return;
    }

    this.currentCollectionId = id;

    let itemsModal = document.getElementById('collection-items-modal');
    if (!itemsModal) {
        this.createItemsModal();
        itemsModal = document.getElementById('collection-items-modal');
    }

    const modalState = ensureItemsModalState(this);
    modalState.selectedIds.clear();
    modalState.searchTerm = '';
    modalState.collection = collection;

    itemsModal.classList.remove('hidden');
    itemsModal.classList.add('flex');
    document.body.style.overflow = 'hidden';

    const modalTitle = itemsModal.querySelector('.modal-title');
    if (modalTitle) {
        modalTitle.textContent = `Dự án trong "${collection.name}"`;
    }

    this.showItemsLoading();

    try {
        const response = await this.api.getCollectionItems(id, { page: 1, per_page: 50 });

        if (!response || !Array.isArray(response.items)) {
            throw new Error('Không thể tải danh sách dự án');
        }

        modalState.items = response.items;
        this.renderCollectionItems(response.items, collection);
        this.resetItemsSearchUI();
        this.updateItemsAfterMutation();
        this.hideItemsLoading();
    } catch (error) {
        console.error('Error loading collection items:', error);
        this.hideItemsLoading();
        this.showItemsError(error.message || 'Không thể tải danh sách dự án');
    }
}

export function createItemsModal() {
    const bulkActionsHTML = `
        <div class="bulk-actions-header px-4 py-3 bg-gray-50 border-b border-gray-200 hidden">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                    <input type="checkbox"
                        id="select-all-items"
                        class="h-4 w-4 text-mps-blue-600 focus:ring-mps-blue-500 border-gray-300 rounded">
                    <label for="select-all-items" class="text-sm font-medium text-gray-700">
                        Chọn tất cả
                    </label>
                    <span class="selected-count text-sm text-gray-500">
                        (<span id="selected-count">0</span> đã chọn)
                    </span>
                </div>
                <button id="bulk-delete-btn"
                    class="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled>
                    <svg class="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    Xóa đã chọn
                </button>
            </div>
        </div>
    `;

    const searchBoxHTML = `
        <div class="search-container px-4 py-3 border-b border-gray-200">
            <div class="relative">
                <input type="text"
                    id="search-items-input"
                    placeholder="Tìm kiếm dự án theo tên..."
                    class="w-full px-3 py-2 pl-10 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-mps-blue-500 focus:border-transparent"
                    autocomplete="off">
                <svg class="absolute left-3 top-2.5 w-5 h-5 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <button id="clear-search"
                    class="absolute right-2 top-2 p-1 text-gray-400 hover:text-gray-600 hidden"
                    type="button"
                    aria-label="Xóa tìm kiếm">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div id="search-results-info" class="mt-2 text-sm text-gray-500 hidden">
                Tìm thấy <span id="results-count">0</span> kết quả
            </div>
        </div>
    `;

    const modalHTML = `
        <div id="collection-items-modal" class="fixed inset-0 bg-black bg-opacity-50 items-center justify-center z-50 hidden">
            <div class="bg-white rounded-lg max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col">
                <div class="p-6 border-b border-gray-200 flex items-center justify-between">
                    <h3 class="text-lg font-medium text-gray-900 modal-title">
                        Dự án trong Collection
                    </h3>
                    <button id="close-items-modal" class="text-gray-400 hover:text-gray-600">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M18 6L6 18"/>
                            <path d="M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
                <div class="flex-1 flex flex-col overflow-hidden">
                    ${bulkActionsHTML}
                    ${searchBoxHTML}
                    <div class="flex-1 overflow-y-auto">
                        <div id="items-loading" class="p-8 text-center">
                            <div class="inline-flex items-center gap-2">
                                <svg class="animate-spin h-5 w-5 text-mps-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                <span class="text-gray-600">Đang tải danh sách dự án...</span>
                            </div>
                        </div>
                        <div id="items-list" class="hidden divide-y divide-gray-200"></div>
                        <div id="items-error" class="hidden p-8 text-center">
                            <div class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
                                </svg>
                            </div>
                            <h3 class="text-lg font-medium text-gray-900 mb-2">Không thể tải danh sách dự án</h3>
                            <p class="text-sm text-gray-500 mb-4" id="items-error-message">Vui lòng thử lại sau</p>
                            <button id="items-retry-btn" class="inline-flex items-center px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white text-sm font-medium rounded-md transition-colors duration-200 gap-2">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M1 4v6h6"/>
                                    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
                                </svg>
                                Thử lại
                            </button>
                        </div>
                        <div id="items-empty" class="hidden p-8 text-center">
                            <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                                </svg>
                            </div>
                            <h3 class="text-lg font-medium text-gray-900 mb-2">Collection trống</h3>
                            <p class="text-sm text-gray-500">Collection này chưa có dự án nào</p>
                        </div>
                    </div>
                </div>
                <div class="p-4 border-t border-gray-200 bg-gray-50">
                    <div class="flex items-center justify-between">
                        <div class="text-sm text-gray-500" id="items-count-info">
                            Hiển thị <span id="items-showing">0</span> dự án
                        </div>
                        <button id="close-items-modal-footer" class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-mps-blue-500">
                            Đóng
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const modal = document.getElementById('collection-items-modal');

    this.attachToggleListeners();
    const closeBtn1 = document.getElementById('close-items-modal');
    const closeBtn2 = document.getElementById('close-items-modal-footer');
    const retryBtn = document.getElementById('items-retry-btn');

    [closeBtn1, closeBtn2].forEach((button) => {
        button?.addEventListener('click', () => this.hideItemsModal());
    });

    modal?.addEventListener('click', (event) => {
        if (event.target === modal) {
            this.hideItemsModal();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal?.classList.contains('hidden')) {
            this.hideItemsModal();
        }
    });

    retryBtn?.addEventListener('click', () => {
        const collectionId = modal.getAttribute('data-collection-id');
        if (collectionId) {
            this.viewCollectionItems(parseInt(collectionId, 10));
        }
    });

    this.initializeItemsModalEvents();
}

export function hideItemsModal() {
    const modal = document.getElementById('collection-items-modal');
    modal?.classList.add('hidden');
    modal?.classList.remove('flex');
    document.body.style.overflow = '';
}

export function showItemsLoading() {
    document.getElementById('items-loading')?.classList.remove('hidden');
    document.getElementById('items-list')?.classList.add('hidden');
    document.getElementById('items-error')?.classList.add('hidden');
    document.getElementById('items-empty')?.classList.add('hidden');
}

export function hideItemsLoading() {
    document.getElementById('items-loading')?.classList.add('hidden');
}

export function showItemsError(message) {
    this.hideItemsLoading();
    document.getElementById('items-error')?.classList.remove('hidden');
    document.getElementById('items-list')?.classList.add('hidden');
    document.getElementById('items-empty')?.classList.add('hidden');

    const errorMessage = document.getElementById('items-error-message');
    if (errorMessage && message) {
        errorMessage.textContent = message;
    }
}
